// @ts-nocheck

import React, { Component, Fragment } from 'react';
import { RootContext, StateContext } from '@/root/root.provider';
import Tickets from './tickets/tickets';
import TicketsRedeemed from './tickets/ticketsRedeemed';
import { redeemTickets } from './envelope/envelope.service';
import walletBannerOpts from './wallet.banners';
import { getRedemptionReasonByCode } from './manage/redemption/redemptionDisabledReasons';

import styles from './wallet.module.scss';
import i18next from 'i18next';
import Spinner from '@/v2/partials/spinner/spinner';
import Banner from '@/v2/partials/banner/banner.tsx';
import { MultiEventEnvelopeModel } from '@/v2/models/multiEventEnvelopeModel.ts';
import { Accordion } from '@ticketmaster/global-design-system';
import EventTicketsHeader from '@/v2/wallet/eventTicketsHeader.tsx';
import { EventTicketsModel } from '@/v2/models/eventTicketsModel.ts';
import Info from '@/v2/wallet/info/info.tsx';
import SidePanel from '@ticketmaster/global-design-system/dist/components/SidePanel/SidePanel';
import { startsBefore } from '@/v2/models/eventModel.ts';

type Props = {
  envelope: MultiEventEnvelopeModel;
  err: any;
};

type State = {
  loading: boolean;
  readyToRenderTickets: boolean;
};

class Wallet extends Component<Props, State> {
  static contextType: React.Context<StateContext> = RootContext;
  token: string = window.location.pathname.substring(1);

  envelope  = this.props.envelope;
  err  = this.props.err;

  state: State = {
    loading: false,
    readyToRenderTickets: false
  };

  async componentDidMount() {
    if (!this.token) {
      return this.context.showBanner(walletBannerOpts.noToken());
    }

    if (this.err) {
      const { status, tmOrdersUrl, message } = this.err.validate;
      switch (status) {
        case 'notReady':
          this.context.showBanner(walletBannerOpts.notReady());
          break;
        case 'alreadyRedeemed':
          this.context.alreadyRedeemed(true);
          this.context.setTmOrdersUrl(tmOrdersUrl);
          break;
        case 'defaultError':
          this.context.showBanner(walletBannerOpts.defaultError());
          break;
        case 'redemptionError':
          this.context.showBanner(walletBannerOpts.redemptionError(getRedemptionReasonByCode(message)));
          break;
        default:
          this.context.showBanner(walletBannerOpts.defaultError());
          break;
      }
    }

    if (this.envelope) {
      await i18next.changeLanguage(this.envelope.userLanguage);
      if (!this.envelope.eventTickets.length) {
        return this.context.showBanner(walletBannerOpts.noTickets());
      }
      if (this.envelope.shouldRedirectToRedemption) {
        this.setState({ loading: true });
        let error = await redeemTickets(this.envelope.activeToken);
        if (error) {
          this.context.showBanner(error);
          this.setState({ loading: false });
        }
      }
    }

    requestAnimationFrame(() => {
      this.setState({ readyToRenderTickets: true });
    });
  }

  render() {
    const { showInfo, activeTicketId } = this.context.state;
    const { envelope } = this.props;
    const redemptionAvailability = envelope?.redemptionAvailability;
    const { banner, alreadyRedeemed } = this.context.state;
    const eventTickets = envelope?.eventTickets || [];
    const hasTickets = (eventTickets: EventTicketsModel) => eventTickets?.tickets?.length > 0;
    const byStartDateTime = (a: EventTicketsModel, b: EventTicketsModel) => startsBefore(a.event, b.event) ? -1 : 1;

    return (
      <div>
        <SidePanel mobileMaxViewportWidth="450px" onClose={() => {this.context.setShowInfo(false)}} isOpen={!!showInfo}>
          <Info active={activeTicketId} envelope={envelope}/>
        </SidePanel>
        <Spinner isShown={this.state.loading} />
        {!this.state.loading && (
          <div className={eventTickets.length > 1 ? styles.multiEventWallet : styles.wallet}>
            {!envelope && <Banner config={banner} />}
            {alreadyRedeemed && <TicketsRedeemed />}
            {!alreadyRedeemed && !!eventTickets && !!eventTickets.length && (
              eventTickets.length > 1 ? (
                <Accordion type="single">
                  {eventTickets.filter(hasTickets).sort(byStartDateTime).map((tickets, index) => (
                    <Accordion.Item key={index} defaultOpen={index === 0}>
                      <Accordion.Header>
                        <EventTicketsHeader event={tickets.event} />
                      </Accordion.Header>
                      <Accordion.Panel>
                        {this.state.readyToRenderTickets && (
                          <Tickets
                            envelope={envelope}
                            eventTickets={tickets}
                            redemptionAvailability={redemptionAvailability}
                          />
                        )}
                      </Accordion.Panel>
                    </Accordion.Item>
                  ))}
                </Accordion>
              ) : (
                hasTickets(eventTickets[0]) && (
                  <Fragment>
                    <Tickets
                      envelope={envelope}
                      eventTickets={eventTickets[0]}
                      redemptionAvailability={redemptionAvailability}
                    />
                  </Fragment>
                )
              )
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Wallet;
